export default __webpack_public_path__ + "static/Image049_Export_small-c27ad57f2205d1bf24452a2557363722.png";